import { Component, input, output } from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { DatatableFooterDirective } from './footer.directive';
import { DataTablePagerComponent } from './pager.component';
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'datatable-footer',
  template: `
      <div
        class="datatable-footer-inner"
        role="row"
        [class.selected-count]="selectedMessage()"
        [style.height.px]="footerHeight()">
        @if (footerTemplate()) {
          <ng-template [ngTemplateOutlet]="footerTemplate().template"
                       [ngTemplateOutletContext]="{
          rowCount: rowCount(),
          pageSize: pageSize(),
          selectedCount: selectedCount(),
          curPage: curPage,
          offset: offset()
        }" />
        }
        @if (!footerTemplate()) {
          <div role="cell" class="page-count">
            @if (selectedMessage()) {
              <span> {{ selectedCount()?.toLocaleString() }} {{ selectedMessage() }} / </span>
            }
            {{ rowCount()?.toLocaleString() }} {{ totalMessage() }}
          </div>
        }
        @if (!footerTemplate()) {
          <datatable-pager role="cell"
                           [pagerLeftArrowIcon]="pagerLeftArrowIcon()"
                           [pagerRightArrowIcon]="pagerRightArrowIcon()"
                           [pagerPreviousIcon]="pagerPreviousIcon()"
                           [pagerNextIcon]="pagerNextIcon()"
                           [page]="curPage"
                           [size]="pageSize()"
                           [count]="rowCount()"
                           [hidden]="!isVisible"
                           (change)="page.emit($event)" />
        }
      </div>
    `,
  host: {
    class: 'datatable-footer',
    '[attr.role]': '\'rowgroup\''
  },
  imports: [NgTemplateOutlet, DataTablePagerComponent]
})
export class DataTableFooterComponent {
  readonly footerHeight = input<number | 'auto'>(undefined);
  readonly rowCount = input<number>(undefined);
  readonly pageSize = input<number>(undefined);
  readonly offset = input<number>(undefined);
  readonly pagerLeftArrowIcon = input<string>(undefined);
  readonly pagerRightArrowIcon = input<string>(undefined);
  readonly pagerPreviousIcon = input<string>(undefined);
  readonly pagerNextIcon = input<string>(undefined);
  readonly totalMessage = input<string>(undefined);
  readonly footerTemplate = input<DatatableFooterDirective>(undefined);

  readonly selectedCount = input<number>(0);
  readonly selectedMessage = input<string | boolean>(undefined);

  readonly page = output<{ page: number }>();

  get isVisible(): boolean {
    return this.rowCount() / this.pageSize() > 1;
  }

  get curPage(): number {
    return this.offset() + 1;
  }
}
